import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { GetRoamingHoursDto, GetRoamingHoursResp } from './get-roaming-hours.type';
import { RoamingRepository } from '@data/repositories/roaming.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetRoamingHoursUsecase implements UseCase<GetRoamingHoursDto, GetRoamingHoursResp> {
    roamingRepository = inject(RoamingRepository);
    execute(payload: GetRoamingHoursDto): Observable<GetRoamingHoursResp> {
        return this.roamingRepository.GetRoamingHours(payload);
    }
}